import React from 'react';
import { motion } from 'framer-motion';

interface PageTransitionProps {
  children: React.ReactNode;
  className?: string;
  key?: string;
}

const PageTransition: React.FC<PageTransitionProps> = ({ children, className = '', key }) => {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5 }}
      key={key}
    >
      {children}
    </motion.div>
  );
};

export default PageTransition; 